import { STATUS_LABELS } from "../../data/programData";

const STYLES = {
  BELUM_MULAI: "bg-gray-100 text-gray-700 border-gray-200",
  ON_PROGRESS: "bg-blue-100 text-blue-800 border-blue-200",
  SELESAI: "bg-emerald-100 text-emerald-800 border-emerald-200",
  TERHAMBAT: "bg-red-100 text-red-800 border-red-200",
};

export default function StatusBadge({ status, className = "" }) {
  const style = STYLES[status] || STYLES.BELUM_MULAI;
  return (
    <span
      data-testid={`status-badge-${status}`}
      className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-[11px] font-semibold ${style} ${className}`}
    >
      <span className={`h-1.5 w-1.5 rounded-full ${DOT[status] || DOT.BELUM_MULAI}`} />
      {STATUS_LABELS[status] || status}
    </span>
  );
}

const DOT = {
  BELUM_MULAI: "bg-gray-400",
  ON_PROGRESS: "bg-blue-500",
  SELESAI: "bg-emerald-500",
  TERHAMBAT: "bg-red-500",
};
